<template>
    <div>
        <text-input :value="data.name" label="Name" ref="name"></text-input>
        <long-text-input :value="data.description" label="Kurzbeschreibung"
                            ref="description"></long-text-input>
        <long-text-input :value="data.longDescription" label="Beschreibung"
                            ref="longDescription"></long-text-input>
        <div class="form-group">
            <label for="#chapter-position">Kapitel Position</label>
            <multiselect id="chapter-position" v-model="position"
                        label="label"
                        :options="positionOptions"
                        :show-labels="false">
            </multiselect>
        </div>
        <div class="form-group">
            <label for="#chapter-position">Titel Position</label>
            <multiselect id="chapter-position" v-model="titlePosition"
                        label="label"
                        :options="titlePositionOptions"
                        :show-labels="false">
            </multiselect>
        </div>
        <entity-multiselect
                entity="tag"
                label="Tags"
                :value="tagIds"
                @input="changedTags"
                name="tags"></entity-multiselect>
        <label><input type="checkbox" v-model="hasImageBackground"> Zeige rosa Hervorhebung hinter Bild</label>
        <file-input v-model="image" label="Bild" type="image"/>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  props: ["data"],
  components: { Multiselect },
  data() {
    return {
      image: this.data.image,
      tagIds: this.data.tagIds,
      hasImageBackground: this.data.hasImageBackground,
      titlePositionValue: this.data.titlePosition,
      titlePositionOptions: [
        { value: 'left', label: "Links" },
        { value: 'right', label: "Rechts" }
      ],
      positionValue: this.data.position,
      positionOptions: [
        { value: 0, label: "Zusammenfassung" },
        { value: 1, label: "Einführung" },
        { value: 2, label: "Herausforderungen" },
        { value: 3, label: "Empfehlungen" }
      ]
    }
  },
  computed: {
    titlePosition: {
      get() {
        return this.titlePositionOptions.find(option => option.value === this.titlePositionValue);
      },
      set(titlePosition) {
        this.titlePositionValue = titlePosition.value;
      }
    },
    position: {
      get() {
        return this.positionOptions[this.positionValue];
      },
      set(position) {
        this.positionValue = position.value;
      }
    }
  },
  methods: {
    changedTags(value) {
      this.tagIds = value;
    },
    saveChapter() {
      let form = new FormData();
      const form_prefix = 'edit_chapter';
      for (let id of this.tagIds) {
        form.append(form_prefix + "[tags][]", id);
      }
      if (this.image && this.image.id) {
        form.append(form_prefix + "[image]", this.image.id);
      } else {
        form.append(form_prefix + "[image]", "");
      }
      form.append(form_prefix + "[position]", this.positionValue);
      form.append(form_prefix + "[titlePosition]", this.titlePositionValue);

      if(this.hasImageBackground)
        form.append(form_prefix + "[hasImageBackground]", this.hasImageBackground);

      form.set(form_prefix + "[submit]", null);
      return axios.post(
        `/api/${store.state.language}/chapter/${this.data.id}/edit`,
        form
      );
    },
    save() {
      store.commit("addSavingProcess");
      Promise.all([
        this.saveChapter(),
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save()
      ])
        .then(({ data }) => {
          store.commit("finishSavingProcess");
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          alert(
            "Beim Speichern ist ein Fehler aufgetreten."
          );
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/chapter/General.vue